import { EffectCallback, useEffect } from 'react';

// eslint-disable-next-line react-hooks/exhaustive-deps
const useMount = (callback: EffectCallback): void => useEffect(callback, []);

export default useMount;
